import { withChartLayout } from 'components/common';
import MedicationReconciliation from 'components/features/chart/patient-data/medication-reconciliation/MedicationReconciliation';

const MedicationReconciliationPage = withChartLayout('MedicationReconciliation')(MedicationReconciliation);
export default MedicationReconciliationPage;
